import { APICore } from 'src/helpers/api/apiCore';
import config from 'src/config';
const apiBaseUrl = config.API_URL;
const api = new APICore();

// add Observation
function creatObservation(params: any) {
    const baseUrl = `/observ/createObservation`;
    return api.create(`${baseUrl}`, params);
}
// update Observation
function updateObservation(params: any) {
    const baseUrl = '/observ/updateObservation';
    return api.update(`${baseUrl}`, params);
}

// get all Observations
function getAllObservation(params: any) {
    const baseUrl = '/observ/getEncTestList';
    return api.create(`${baseUrl}`, params);
}

// get all Observations
function getObservations(params: any) {
    const baseUrl = '/observ/getObservList';
    return api.create(`${baseUrl}`, params);
}

// get all Observations status
function getObservationStatus(params: any) {
    const baseUrl = '/observ/getEncTestList';
    return api.create(`${baseUrl}`, params);
}

// get all Observation reports
function getObservationReport(params: any) {
    const baseUrl = '/observ/repReady';
    return api.create(`${baseUrl}`, params);
}

// get Observation
function getObservation(params: any) {
    const baseUrl = '/observ/getObservationDetail';
    return api.create(`${baseUrl}`, params);
}

// delete Observation
function deleteObservation(params: any) {
    const baseUrl = '/observ/removeObserv';
    return api.create(`${baseUrl}`, params);
}

// send pdf email observation
function sendEmailObservation(params: any) {
    const baseUrl = `/pdfgen/createpdf`;
    return api.createWithFile(`${baseUrl}`, params);
}

export {
    creatObservation,
    updateObservation,
    getAllObservation,
    getObservation,
    deleteObservation,
    getObservationReport,
    getObservations,
    sendEmailObservation,
    getObservationStatus,
};
